import * as React from "react";

interface IconProps {
    className?: string;
}

export function TimesCircleIcon({ className }: IconProps = {}) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_2104_40610)">
                <path
                    d="M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM17.7 15.0516C17.9203 15.2719 17.9203 15.6281 17.7 15.8484L15.8438 17.7C15.6234 17.9203 15.2672 17.9203 15.0469 17.7L12 14.625L8.94844 17.7C8.72812 17.9203 8.37187 17.9203 8.15156 17.7L6.3 15.8438C6.07969 15.6234 6.07969 15.2672 6.3 15.0469L9.375 12L6.3 8.94844C6.07969 8.72812 6.07969 8.37187 6.3 8.15156L8.15625 6.29531C8.37656 6.075 8.73281 6.075 8.95312 6.29531L12 9.375L15.0516 6.3C15.2719 6.07969 15.6281 6.07969 15.8484 6.3L17.7047 8.15625C17.925 8.37656 17.925 8.73281 17.7047 8.95312L14.625 12L17.7 15.0516Z"
                    fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_2104_40610">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export function ExclamationCircleIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2104_40583)">
                <path
                    d="M23.625 12C23.625 18.4217 18.4199 23.625 12 23.625C5.58014 23.625 0.375 18.4217 0.375 12C0.375 5.58202 5.58014 0.375 12 0.375C18.4199 0.375 23.625 5.58202 23.625 12ZM12 14.3438C10.8091 14.3438 9.84375 15.3091 9.84375 16.5C9.84375 17.6909 10.8091 18.6562 12 18.6562C13.1909 18.6562 14.1562 17.6909 14.1562 16.5C14.1562 15.3091 13.1909 14.3438 12 14.3438ZM9.95283 6.59316L10.3005 12.9682C10.3168 13.2665 10.5635 13.5 10.8622 13.5H13.1378C13.4365 13.5 13.6832 13.2665 13.6995 12.9682L14.0472 6.59316C14.0648 6.27094 13.8082 6 13.4855 6H10.5144C10.1917 6 9.93525 6.27094 9.95283 6.59316Z"
                    fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_2104_40583">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export function CalendarAltIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5 21.75C1.5 22.9922 2.50781 24 3.75 24H20.25C21.4922 24 22.5 22.9922 22.5 21.75V9H1.5V21.75ZM16.5 12.5625C16.5 12.2531 16.7531 12 17.0625 12H18.9375C19.2469 12 19.5 12.2531 19.5 12.5625V14.4375C19.5 14.7469 19.2469 15 18.9375 15H17.0625C16.7531 15 16.5 14.7469 16.5 14.4375V12.5625ZM16.5 18.5625C16.5 18.2531 16.7531 18 17.0625 18H18.9375C19.2469 18 19.5 18.2531 19.5 18.5625V20.4375C19.5 20.7469 19.2469 21 18.9375 21H17.0625C16.7531 21 16.5 20.7469 16.5 20.4375V18.5625ZM10.5 12.5625C10.5 12.2531 10.7531 12 11.0625 12H12.9375C13.2469 12 13.5 12.2531 13.5 12.5625V14.4375C13.5 14.7469 13.2469 15 12.9375 15H11.0625C10.7531 15 10.5 14.7469 10.5 14.4375V12.5625ZM10.5 18.5625C10.5 18.2531 10.7531 18 11.0625 18H12.9375C13.2469 18 13.5 18.2531 13.5 18.5625V20.4375C13.5 20.7469 13.2469 21 12.9375 21H11.0625C10.7531 21 10.5 20.7469 10.5 20.4375V18.5625ZM4.5 12.5625C4.5 12.2531 4.75313 12 5.0625 12H6.9375C7.24687 12 7.5 12.2531 7.5 12.5625V14.4375C7.5 14.7469 7.24687 15 6.9375 15H5.0625C4.75313 15 4.5 14.7469 4.5 14.4375V12.5625ZM4.5 18.5625C4.5 18.2531 4.75313 18 5.0625 18H6.9375C7.24687 18 7.5 18.2531 7.5 18.5625V20.4375C7.5 20.7469 7.24687 21 6.9375 21H5.0625C4.75313 21 4.5 20.7469 4.5 20.4375V18.5625ZM20.25 3H18V0.75C18 0.3375 17.6625 0 17.25 0H15.75C15.3375 0 15 0.3375 15 0.75V3H9V0.75C9 0.3375 8.6625 0 8.25 0H6.75C6.3375 0 6 0.3375 6 0.75V3H3.75C2.50781 3 1.5 4.00781 1.5 5.25V7.5H22.5V5.25C22.5 4.00781 21.4922 3 20.25 3Z"
                fill="white"/>
        </svg>
    );
}

export function RocketIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.6775 0.89502C23.6218 0.635742 23.3654 0.379395 23.1053 0.32373C21.5961 0 20.4144 0 19.2379 0C14.3988 0 11.497 2.58765 9.33058 6H4.44552C3.67922 6.00073 2.7788 6.55664 2.43521 7.24146L0.11792 11.8733C0.0463074 12.0312 0.00625032 12.2017 0 12.375C0.00010775 12.6734 0.118706 12.9595 0.32972 13.1705C0.540734 13.3814 0.82689 13.5 1.12527 13.5H5.99138L4.93789 14.5532C4.40514 15.0858 4.3287 16.0653 4.93789 16.6743L7.32402 19.0605C7.84697 19.585 8.83134 19.6772 9.44639 19.0605L10.4999 18.0073V22.875C10.5 23.1734 10.6186 23.4595 10.8296 23.6705C11.0406 23.8814 11.3268 24 11.6252 24C11.7985 23.9936 11.969 23.9535 12.1271 23.8821L16.7549 21.5669C17.4407 21.2249 17.9975 20.3247 17.9975 19.5579V14.6624C21.4005 12.4915 23.9991 9.58081 23.9991 4.76733C24.0035 3.58594 24.0035 2.40454 23.6775 0.89502ZM18.0019 7.875C17.6311 7.87491 17.2686 7.76487 16.9603 7.55879C16.652 7.3527 16.4118 7.05984 16.2699 6.71722C16.1281 6.3746 16.091 5.99761 16.1634 5.63393C16.2358 5.27024 16.4144 4.93619 16.6767 4.67401C16.9389 4.41184 17.273 4.2333 17.6367 4.16099C18.0004 4.08868 18.3774 4.12584 18.72 4.26777C19.0626 4.4097 19.3554 4.65002 19.5614 4.95835C19.7674 5.26669 19.8773 5.62918 19.8773 6C19.8771 6.49727 19.6794 6.97409 19.3277 7.32567C18.976 7.67725 18.4992 7.87483 18.0019 7.875Z"
                fill="white"/>
        </svg>
    );
}

export function HeartIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2140_166)">
                <path
                    d="M21.4875 2.51509C18.7781 0.236965 14.5922 0.579152 12 3.21821C9.40782 0.579152 5.22188 0.232277 2.51251 2.51509C-1.01249 5.48228 -0.49687 10.3198 2.01563 12.8838L10.2375 21.2604C10.7063 21.7385 11.3344 22.0057 12 22.0057C12.6703 22.0057 13.2938 21.7432 13.7625 21.2651L21.9844 12.8885C24.4922 10.3245 25.0172 5.48696 21.4875 2.51509ZM20.3813 11.3042L12.1594 19.6807C12.0469 19.7932 11.9531 19.7932 11.8406 19.6807L3.61875 11.3042C1.90782 9.5604 1.56094 6.2604 3.96094 4.24009C5.78438 2.70728 8.59688 2.93696 10.3594 4.73228L12 6.40571L13.6406 4.73228C15.4125 2.92759 18.225 2.70728 20.0391 4.2354C22.4344 6.25571 22.0781 9.57446 20.3813 11.3042Z"
                    fill="#333333"/>
                <path
                    d="M21.4875 2.51509C18.7781 0.236965 14.5922 0.579152 12 3.21821C9.40782 0.579152 5.22188 0.232277 2.51251 2.51509C-1.01249 5.48228 -0.49687 10.3198 2.01563 12.8838L10.2375 21.2604C10.7063 21.7385 11.3344 22.0057 12 22.0057C12.6703 22.0057 13.2938 21.7432 13.7625 21.2651L21.9844 12.8885C24.4922 10.3245 25.0172 5.48696 21.4875 2.51509ZM20.3813 11.3042L12.1594 19.6807C12.0469 19.7932 11.9531 19.7932 11.8406 19.6807L3.61875 11.3042C1.90782 9.5604 1.56094 6.2604 3.96094 4.24009C5.78438 2.70728 8.59688 2.93696 10.3594 4.73228L12 6.40571L13.6406 4.73228C15.4125 2.92759 18.225 2.70728 20.0391 4.2354C22.4344 6.25571 22.0781 9.57446 20.3813 11.3042Z"
                    fill="white" fillOpacity="0.25"/>
            </g>
            <defs>
                <clipPath id="clip0_2140_166">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export function HeartFilledIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3190_91682)">
                <path
                    d="M21.6699 2.93422C19.1012 0.74516 15.2808 1.13891 12.923 3.57172L11.9996 4.52328L11.0762 3.57172C8.72304 1.13891 4.89804 0.74516 2.32929 2.93422C-0.614464 5.44672 -0.769152 9.9561 1.86522 12.6795L10.9355 22.0452C11.5215 22.6498 12.473 22.6498 13.059 22.0452L22.1293 12.6795C24.7683 9.9561 24.6137 5.44672 21.6699 2.93422Z"
                    fill="#C1272D"/>
            </g>
            <defs>
                <clipPath id="clip0_3190_91682">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export function InfoCircleIcon({className, fill = "white"}: {className?: string, fill?: string}) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_2125_6099)">
                <path
                    d="M12 0.375C5.58014 0.375 0.375 5.58202 0.375 12C0.375 18.4217 5.58014 23.625 12 23.625C18.4199 23.625 23.625 18.4217 23.625 12C23.625 5.58202 18.4199 0.375 12 0.375ZM12 5.53125C13.0873 5.53125 13.9688 6.41269 13.9688 7.5C13.9688 8.58731 13.0873 9.46875 12 9.46875C10.9127 9.46875 10.0312 8.58731 10.0312 7.5C10.0312 6.41269 10.9127 5.53125 12 5.53125ZM14.625 17.4375C14.625 17.7481 14.3731 18 14.0625 18H9.9375C9.62686 18 9.375 17.7481 9.375 17.4375V16.3125C9.375 16.0019 9.62686 15.75 9.9375 15.75H10.5V12.75H9.9375C9.62686 12.75 9.375 12.4981 9.375 12.1875V11.0625C9.375 10.7519 9.62686 10.5 9.9375 10.5H12.9375C13.2481 10.5 13.5 10.7519 13.5 11.0625V15.75H14.0625C14.3731 15.75 14.625 16.0019 14.625 16.3125V17.4375Z"
                    fill={fill}/>
            </g>
            <defs>
                <clipPath id="clip0_2125_6099">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export function VerticalResize() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
             viewBox="0 0 16 16" version="1.1">
            <rect width="16" height="16" id="icon-bound" fill="none"/>
            <path
                d="M0,6.999v2.002h16V6.999H0z M7,3.828V6h2V3.828l1.586,1.586L12,4L8,0L4,4l1.414,1.414L7,3.828z M9,12.172V10H7v2.172 l-1.586-1.586L4,12l4,4l4-4l-1.414-1.414L9,12.172z"/>
        </svg>
    );
}